export default {
  methods: {
    async confirmDelete (func) {
      const result = await this.$dialog.confirm({
        title: this.$t('shared.delete'),
        text: this.$t('shared.delete-question')
      })

      if (result)
        return await func()
    }
  }
}
